import type { RefObject } from 'react';
import './ProgressBar.css';
import finishFlagIcon from './finish_flag_icon.png';
import packageIcon from '../../loading_screen/icon.png';
import type { PlayfieldMotionBindings } from '../gameplay/playfieldMotionBindings';

/** Figma progress_bar_background (130:21296) — 139.8135 151.8711 800.3734×74.1494 */
const BAR_LEFT = 139.8135;
const BAR_TOP = 151.8711;
export const PROGRESS_BAR_WIDTH = 800.3734;
const BAR_HEIGHT = 74.1494;

/** Figma progress_bar_scale (130:21297) default width. */
const FIGMA_FILL_WIDTH = 289.3804;

/** Former timer_icon slot — 50.0654 103.04, height 150 like the flag. */
const PACKAGE_LEFT = 50.0654;
const PACKAGE_TOP = 103.04;
const PACKAGE_HEIGHT = 150;
/** loading_screen icon.png Figma size 180.734×209.041 */
const PACKAGE_WIDTH = PACKAGE_HEIGHT * (180.73376712583558 / 209.04105957095817);

/** finish_flag_icon — 922 100, asset 127×150 */
const FLAG_LEFT = 922;
const FLAG_TOP = 100;
const FLAG_WIDTH = 127;
const FLAG_HEIGHT = 150;

export type ProgressBarProps = {
  /** Initial progress 0–1 (continuous updates go through motionBindings). */
  value?: number;
  motionBindings?: RefObject<PlayfieldMotionBindings | null>;
};

/** Figma progress HUD — track + fill + package/flag icons. */
export function ProgressBar({
  value = FIGMA_FILL_WIDTH / PROGRESS_BAR_WIDTH,
  motionBindings,
}: ProgressBarProps) {
  const progress = Math.max(0, Math.min(1, value));
  const fillWidth = progress * PROGRESS_BAR_WIDTH;

  if (motionBindings?.current != null) {
    motionBindings.current.progressBarWidth = PROGRESS_BAR_WIDTH;
  }

  return (
    <>
      <div
        ref={(el) => {
          if (motionBindings?.current != null) {
            motionBindings.current.progressBar = el;
          }
        }}
        className="progress-bar__bar"
        style={{
          left: BAR_LEFT,
          top: BAR_TOP,
          width: PROGRESS_BAR_WIDTH,
          height: BAR_HEIGHT,
        }}
        role="progressbar"
        aria-label="Прогресс уровня"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={Math.round(progress * 100)}
      >
        <div className="progress-bar__track">
          <div className="progress-bar__track-fill" />
          <div className="progress-bar__track-shade" />
        </div>
        <div
          ref={(el) => {
            if (motionBindings?.current != null) {
              motionBindings.current.progressFill = el;
            }
          }}
          className="progress-bar__scale"
          style={{ width: fillWidth, display: fillWidth > 0 ? undefined : 'none' }}
        >
          <div className="progress-bar__scale-fill" />
          <div className="progress-bar__scale-shade" />
        </div>
      </div>

      <img
        className="progress-bar__icon"
        src={packageIcon}
        alt=""
        draggable={false}
        aria-hidden
        style={{
          left: PACKAGE_LEFT,
          top: PACKAGE_TOP,
          width: PACKAGE_WIDTH,
          height: PACKAGE_HEIGHT,
        }}
      />
      <img
        className="progress-bar__flag"
        src={finishFlagIcon}
        alt=""
        draggable={false}
        aria-hidden
        style={{
          left: FLAG_LEFT,
          top: FLAG_TOP,
          width: FLAG_WIDTH,
          height: FLAG_HEIGHT,
        }}
      />
    </>
  );
}
